module.exports = {
  items: [
    "1.2.840.10008.1.2",
    "1.2.840.10008.1.2.1",
    "1.2.840.10008.1.2.2",
    "1.2.840.10008.1.2.4.57",
    "1.2.840.10008.1.2.4.70",
    "1.2.840.10008.1.2.4.80",
    "1.2.840.10008.1.2.4.81",
    "1.2.840.10008.1.2.4.90",
    "1.2.840.10008.1.2.4.91",
    "1.2.840.10008.1.2.4.92",
    "1.2.840.10008.1.2.4.93",
    "1.2.840.10008.1.2.4.94",
    "1.2.840.10008.1.2.4.95",
    "1.2.840.10008.1.2.4.100",
    "1.2.840.10008.1.2.5"
  ],
  default: [
    "1.2.840.10008.1.2.4.90",
    "1.2.840.10008.1.2.4.70",
    "1.2.840.10008.1.2.1",
  ],
  translate_name(uid_arr) {
    var result = new Array();
    uid_arr.forEach(function (uid) {
      switch (uid) {
        case "1.2.840.10008.1.2":
          result.push("ImplicitVRLittleEndian");
          break;
        case "1.2.840.10008.1.2.1":
          result.push("ExplicitVRLittleEndian");
          break;
        case "1.2.840.10008.1.2.2":
          result.push("ExplicitVRBigEndian");
          break;
        case "1.2.840.10008.1.2.4.57":
          result.push("JPEGLosslessProcess14");
          break;
        case "1.2.840.10008.1.2.4.70":
          result.push("JPEGLosslessProcess14_1");
          break;
        case "1.2.840.10008.1.2.4.80":
          result.push("JPEGLSLossless");
          break;
        case "1.2.840.10008.1.2.4.81":
          result.push("JPEGLSNearLossless");
          break;
        case "1.2.840.10008.1.2.4.90":
          result.push("JPEG2000Lossless");
          break;
        case "1.2.840.10008.1.2.4.91":
          result.push("JPEG2000");
          break;
        case "1.2.840.10008.1.2.4.92":
          result.push("JPEG2000Part2Lossless");
          break;
        case "1.2.840.10008.1.2.4.93":
          result.push("JPEG2000Part2");
          break;
        case "1.2.840.10008.1.2.4.94":
          result.push("JPIPReferenced");
          break;
        case "1.2.840.10008.1.2.4.95":
          result.push("JPIPReferencedDeflated");
          break;
        case "1.2.840.10008.1.2.4.100":
          result.push("MPEG2MainProfile");
          break;
        case "1.2.840.10008.1.2.5":
          result.push("RLELossless");
          break;
        default:
          result.push("");
      }
    });
    return result;
  },
  translate_uid(name_arr) {
    var result = new Array();
    name_arr.forEach(function (name) {
      switch (name) {

        case "ImplicitVRLittleEndian":
          result.push("1.2.840.10008.1.2");
          break;
        case "ExplicitVRLittleEndian":
          result.push("1.2.840.10008.1.2.1");
          break;
        case "ExplicitVRBigEndian":
          result.push("1.2.840.10008.1.2.2");
          break;
        case "JPEGLosslessProcess14":
          result.push("1.2.840.10008.1.2.4.57");
          break;
        case "JPEGLosslessProcess14_1":
          result.push("1.2.840.10008.1.2.4.70");
          break;
        case "JPEGLSLossless":
          result.push("1.2.840.10008.1.2.4.80");
          break;
        case "JPEGLSNearLossless":
          result.push("1.2.840.10008.1.2.4.81");
          break;
        case "JPEG2000Lossless":
          result.push("1.2.840.10008.1.2.4.90");
          break;
        case "JPEG2000":
          result.push("1.2.840.10008.1.2.4.91");
          break;
        case "JPEG2000Part2Lossless":
          result.push("1.2.840.10008.1.2.4.92");
          break;
        case "JPEG2000Part2":
          result.push("1.2.840.10008.1.2.4.93");
          break;
        case "JPIPReferenced":
          result.push("1.2.840.10008.1.2.4.94");
          break;
        case "JPIPReferencedDeflated":
          result.push("1.2.840.10008.1.2.4.95");
          break;
        case "MPEG2MainProfile":
          result.push("1.2.840.10008.1.2.4.100");
          break;
        case "RLELossless":
          result.push("1.2.840.10008.1.2.5");
          break;
        default:
          result.push("");
      }
    });
    return result;
  },
};

